<template>
    <div class="rounded-25 bg-white content-desktop">
        <div class="text-tc-blue-1 flex justify-between pt-5 pb-6">
            <div>
                <span class="text-24 whitespace-nowrap">{{ menuName }}</span>
                <span class="text-18 pl-1 whitespace-nowrap">({{ menuCount }} {{lbl.profile.carried}})</span>
                <span class="text-24 px-2 underline cursor-pointer" @click="onclickRefresh()">{{lbl.profile.refresh}}</span>
            </div>
            <div class="flex" v-if="hasData">
                <div class="flex-none">
                    <BackBtn :isDisable="disabledPrv" @onClick="prvSlide()"/>
                </div>
                <div class="pl-4">
                    <NextBtn :isDisable="disabledNext" @onClick="nextSlide()"/>
                </div>
            </div>
        </div>
        <div v-if="isLoadSlide">
            <div class="splide custom-slide" id="dashboard-slide">
                <div class="splide__track">
                    <ul class="splide__list">
                        <li class="splide__slide"
                            v-for="(item, k) in list"
                            :key="k"
                            @click="clickDashboard(dashboard)">
                            <!-- height-blackground mx-2 mb-5 px-4 pt-18px border border-tc-gray-4 rounded-10 bg-white -->
                            <div class="h-400px w-250px px-4 pt-18px border rounded-10 bg-white " :class="[item.isWarning ? 'border-a-red-eb1c24' : 'border-tc-gray-4']">
                                <div class="flex justify-center">
                                    <img class="w-12 img-height" src="../../../assets/insurance-car-icon.png" />
                                </div>
                                <div class="text-22 text-tc-blue-1 pb-4 text-center">{{ item.policyName }}</div>
                                    <div class="text-center text-20">
                                        <div>
                                            <span>{{lbl.profile.member_name}}</span>
                                            <span>-</span>
                                        </div>
                                        <div>
                                            <span>{{lbl.profile.policy_name}}</span>
                                            <span>{{ item.policyNumber }}</span>
                                        </div>
                                        <div v-if="item.carId">
                                            <span>{{lbl.profile.vehicle_number}} </span>
                                            <span>-</span>
                                        </div>
                                        <div>
                                            <span>{{lbl.profile.effective_date}}</span>
                                            <span>{{ FiltertDateFormatShortMonth(item.coverageStartDate) }}</span>
                                        </div>
                                        <div class="inline-flex">
                                            <div>
                                                <span>{{lbl.profile.expire_date}}</span>
                                                <span>{{ FiltertDateFormatShortMonth(item.coverageEndDate) }}</span>
                                            </div>
                                            <div class="pl-1 pt-1">
                                                <img v-if="item.isWarning" src="@/assets/insurance-warning-icon.png" />
                                            </div>
                                        </div>
                                    </div>
                                <div class="pt-3 text-18 text-tc-blue-1 text-center">
                                    <span class="text-red-600">*</span>
                                    {{lbl.profile.insuenace_term}}
                                </div>
                                <div class="pt-3" v-if="item.policyStatus == 'Renew'">
                                    <RedBtn @click="validateRenews(item)">{{lbl.profile.renewal_insurance}}</RedBtn>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="!hasData" class="text-center flex justify-center">
            <div class="my-9">
                <img class="w-7 mx-auto" src="@/assets/icon/warning-icon.png">
                <div class="pt-3">
                    <span class="text-20 text-tc-blue-1 ">{{lbl.profile.no_data}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import Util from '@/helper/Utility.js';
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
import NextBtn from '@/components/Button/NextBtn.vue';
import BackBtn from '@/components/Button/BackBtn.vue';
import RedBtn from '@/components/Button/RedBtn.vue';
//mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
//service
import InsuranceService from '../service/InsuranceService.js';
import ConfigManager from '@/config/ConfigManager.js';
import BzbsProfile from '@/core/Account/service/BzbsProfile'
import LocaleMixin from '@/mixin/LocaleMixin.js';
export default {
    name: 'Menu',
    inject: ["AccountStore"],
    mixins: [AuthStatusMixin, LocaleMixin],
    components:{
        NextBtn,
        BackBtn,
        RedBtn
    },
    props:{
        modalController: Object,
        profileInfo: Object,
    },
    data() {
        return {
            list: [],
            menuName: '',
            menuCount: 0,
            slider: null,
            currentSliderIndex: 0,
            disabledNext: false,
            disabledPrv: true,
            isLoadSlide: false,
        };
    },
    computed:{
        hasData: function(){
            return this.list.length > 0
        }
    },
    created: function(){
        this.menuName = this.lbl.profile.my_insurance;
    },
    mounted() {

    },
    methods: {
        // AuthStatusMixin
        onAccountInit: async function() {
            this.isLoadSlide = false;
            let success = await this.getInsurance();
            if (success) {
                this.isLoadSlide = true;
                this.setSlider();
            }
        },
        getInsurance: function() {
            return new Promise((resolve) => {
                let profile = this.profile;
                this.list = [];
                InsuranceService.getInsurance(profile).subscribe({
                    next: (data) => {
                        console.log('insurance', data);
                        this.list = data;
                        this.menuCount = this.list.length;
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        this.errorApi(err);
                        resolve(false);
                    },
                });
            });
        },

        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide('#dashboard-slide', {
                    // type: 'loop',
                    arrows: false,
                    padding: 0,
                    gap: 10,
                    autoWidth: true,
                    breakpoints: {
                        640: {
                            // padding: 30,
                        },
                    }
                }).mount();
                this.slider.on('move', (newIndex) => {
                    console.log(newIndex);
                    this.currentSliderIndex = newIndex;
                });
            });
        },
        nextSlide: function(){
            let next = this.currentSliderIndex + 1;
            console.log('next' , next);
            this.disabledPrv = false
            if(next === this.list.length){
                this.disabledNext = true
                this.disabledPrv = false
            }
            this.slider.go(next);
        },
        prvSlide: function() {
            let prev = this.currentSliderIndex - 1;
            console.log('prev' , prev);
            this.disabledNext = false
            if(prev === -1){
                this.disabledPrv = true
                this.disabledNext = false
            }
            this.slider.go(prev);
        },
        clickRenew: function() {

            let url = ConfigManager.getUrlRenewInsurance();
            window.location = url;
        },
        onclickRefresh: async function(){
            this.isLoadSlide = false;
            this.modalController.loadingModal.show();
            await this.getUpdatePointApi();
            let point = await this.AccountStore.methods.apiUpdatePoint();
            if (point) {
                this.$emit('updatePoint', point); 
            }

            let success = await this.getInsurance();
            if (success) {
                this.isLoadSlide = true;
                this.setSlider();
            }
            this.modalController.loadingModal.hide();

        },
        getUpdatePointApi: function(){
            return new Promise((resolve) => {
                BzbsProfile.getUpdatePoint().subscribe({
                    next: (res) => {
                        console.log(res)
                        resolve(res)
                },
                error: (err) => {
                    this.errorApi(err);
                    resolve(false)
                },
                })
            })
        },
        validateRenews: function(item){

            this.modalController.loadingModal.show();
            console.log(item);
            var params = {
                idcard: this.profileInfo.idcard,
                policyNo: item.policyNumber,
                insuranceClass: "MI",
            }
            return new Promise((resolve) => {
                BzbsProfile.validateRenew(params).subscribe({
                    next: (res) => {

                        this.modalController.loadingModal.hide();
                        window.open(res.data)
                        console.log(res)
                        resolve(res)
                },
                error: (err) => {
                    this.modalController.loadingModal.hide();
                    this.errorApi(err);
                    resolve(false)
                },
                })
            })
        }
    },
};
</script>

<style lang="scss" scoped>
    .content-desktop{
        padding: 15px 19.3px 0 19.3px; //top right bottom left
    }
    .img-height{
        height: 37.49px;
    }
</style>
